import { Section } from "@/components/layout/Section";
import { Container } from "@/components/layout/Container";
import { ContactForm } from "./ContactForm";
import { LogoIcon } from "@/components/ui/Logo";

export function Contact() {
  return (
    <Section id="contact" className="bg-sage-light/30">
      <Container className="max-w-xl">
        <h2 className="text-3xl sm:text-4xl font-light tracking-tight text-foreground text-center mb-4">
          Get in Touch
        </h2>
        <p className="text-center text-muted-foreground mb-12">
          Have a question or want to work together? Drop us a message.
        </p>

        <ContactForm />
      </Container>

      {/* Footer */}
      <div className="mt-24 text-center">
        <LogoIcon className="w-8 h-8 mx-auto mb-4 text-muted-foreground/50" />
        <p className="text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} Bakerysoft. All rights reserved.
        </p>
      </div>
    </Section>
  );
}
